module.exports = __webpack_public_path__ + "img/0d7a11d.jpg";